import { socket, getSocketConnectionData } from '@speechki-frontend/core/socket';
import { getToken } from '@speechki-frontend/core/auth/utils';

import { mergeBookparts as apiMergeBookparts } from '../api/bookparts';

const TIMEOUT_LENGTH = 20000;
const ERROR_MESSAGE = [
    {
        detail: 'Generation error, please try again'
    }
];

/**
 * Merges sentences with repsonse by WS and timeout fallback
 * @param {*} subject subject bookpart id
 * @param {*} target target bookpart id
 */
export const mergeBookparts = async (subject, target, callback = () => {}) => {
    let promiseResolve, promiseReject, timeout;
    window.onbeforeunload = () => {
        clearTimeout(timeout);
    };

    await apiMergeBookparts(subject, target);

    const ws = socket(getSocketConnectionData(getToken()));

    ws.receiver.on('record_process_book_part_update', handleMessage);

    const off = () => {
        ws.receiver.on('record_process_book_part_update', handleMessage);
    };

    async function handleMessage({ code, params }) {
        if (code !== 200) {
            off();
            return promiseReject(ERROR_MESSAGE);
        }

        await callback(params);

        if (params.action === 'gluing' && params.is_completed) {
            const [id] = params.extra_data.bp_ids;

            if (id === subject) {
                off();
                clearTimeout(timeout);
                timeout = null;

                return promiseResolve();
            }
        }
    }

    return new Promise((resolve, reject) => {
        promiseResolve = resolve;
        promiseReject = reject;

        timeout = setTimeout(() => {
            return resolve();
        }, TIMEOUT_LENGTH);
    });
};
